import { removeAccents } from "@repo/core/utils/string.utils";
import { joinPhoneDigits } from "@repo/core/utils/phone.utils";

export type CityOption = { label: string; value: string };

export const normalizeZipCodeForInput = (zipCode?: string | null): string => {
  const digits = (zipCode || "").replace(/\D/g, "");
  return digits === "00000000" ? "" : digits;
};

export const shouldClearAdditionalPhoneType = (
  phone: string | undefined,
  phoneType: string | undefined
): boolean => {
  const phoneDigits = (phone || "").replace(/\D/g, "");

  return phoneDigits.length === 0 && Boolean(phoneType?.trim());
};

export const resolveAddressPrimaryPhone = (
  primaryDdd?: string | null,
  primaryNumber?: string | null,
  fallbackPhone?: string | null
): string => {
  const phoneFromPreProposal = joinPhoneDigits(primaryDdd, primaryNumber);

  return primaryDdd?.trim() && primaryNumber?.trim()
    ? phoneFromPreProposal
    : (fallbackPhone || "").replace(/\D/g, "");
};

/**
 * Finds a city option value matching the raw name, ignoring accents and casing.
 */
export const matchCityOptionValue = (
  rawCity: string,
  options: CityOption[]
): string | undefined => {
  const trimmed = rawCity?.trim();
  if (!trimmed || !options.length) return undefined;

  const normalizedRaw = removeAccents(trimmed.toLowerCase());
  const match = options.find(
    (opt) => removeAccents(opt.value.trim().toLowerCase()) === normalizedRaw
  );
  return match?.value;
};

export const statesOptions = [
  { value: "AC", label: "Acre" },
  { value: "AL", label: "Alagoas" },
  { value: "AP", label: "Amapá" },
  { value: "AM", label: "Amazonas" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "DF", label: "Distrito Federal" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PA", label: "Pará" },
  { value: "PB", label: "Paraíba" },
  { value: "PR", label: "Paraná" },
  { value: "PE", label: "Pernambuco" },
  { value: "PI", label: "Piauí" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "RO", label: "Rondônia" },
  { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
  { value: "SE", label: "Sergipe" },
  { value: "TO", label: "Tocantins" }
];
